import React from 'react';
import {Link } from "react-router-dom";

const HomeSection = (props) => {

  const bodyText = props.bodyText
  const subheadline = props.subheadline
  const color = props.color
  const linkTo = props.linkTo
  const linkText = props.linkText

  return (
    <div className={"tab-content-" + color }>
       <div className="tab-pane fade show active" id="tasks" role="tabpanel" data-filter-list="card-list-body">
          <div className="row content-list-head">
             <div className="col-auto">
                <h2 className="projectlist">{ subheadline }</h2>
             </div>
          </div>
          <div className="content-list-body dashboard">
            { bodyText }
          </div>
          <div className="dashboard-btn-right">
            <Link to={linkTo}>
              <button type="button" className="btn-dashboard">{ linkText }</button>
            </Link>
          </div>
       </div>
    </div>
  )
};

export default HomeSection;



// WEBPACK FOOTER //
// ./src/components/Home/HomeSection.js